import { render, staticRenderFns } from "./Extensiv.vue?vue&type=template&id=30fd0431"
import script from "./Extensiv.vue?vue&type=script&lang=js"
export * from "./Extensiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports